import { useEffect, useState } from 'react'
import { useGetOrderByQueryMutation } from '@/shared/api-rtk/index.js'
import { useDebounce } from '@uidotdev/usehooks'

export const SearchOrder = ({
    orderFromCard,
    formData,
    setFormData,
    errorsForm,
    setErrors,
    errors,
}) => {
    const [foundOrders, setFoundOrders] = useState([])
    const [orderName, setOrderName] = useState('')
    const [inputFocused, setInputFocused] = useState(false)
    const [getOrderName] = useGetOrderByQueryMutation()
    const debouncedSearchTerm = useDebounce(orderName, 500)

    useEffect(() => {
        getOrderName(debouncedSearchTerm)
            .unwrap()
            .then((res) => setFoundOrders(res.products.slice(0, 5)))
    }, [debouncedSearchTerm])

    const handleChangeInput = (e) => {
        setOrderName(e.target.value)
        setFormData({ ...formData, orderName: '' })
    }

    const handleSelectOrder = (order) => {
        //Изменение состояния и значения инпута
        setInputFocused(false)
        setOrderName(order.name)
        setErrors({ ...errors, orderName: false })

        //Изменение объекта формы
        setFormData({ ...formData, orderName: order.product_id })
    }

    return (
        <div className={'SearchOrder'}>
            <input
                type="text"
                onFocus={() => setInputFocused(true)}
                name="orderName"
                value={orderFromCard || orderName}
                disabled={orderFromCard}
                className={`input ${errorsForm.orderName ? 'error-input' : ''}`}
                placeholder="Введите название товара"
                onChange={(e) => handleChangeInput(e)}
            />
            {inputFocused && !!foundOrders.length && (
                <div className={'orders'}>
                    {foundOrders.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => handleSelectOrder(item)}
                            className={'found-order'}
                        >
                            {item.name}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
